export default __webpack_public_path__ + "static/media/errors3.cacfaf0d.jpg";